import { Box, Container } from "@mui/material";
import React from "react";
import Title from "../../components/title";
import img from "../../images/about.png";

const About = () => {
  return (
    <Container sx={{ mt: { xs: 5, md: "10%" } }}>
      <Box sx={{ display: { md: "flex" } }} className="items-center">
        <Box sx={{ width: { md: "70%" } }}>
          <Title title={"About Me"} />
          <p className="text-white mt-7">
            Assalamualaikum. It's Khurshida Jahan Meem, and I am currently
            employed as a Junior Frontend Software Developer at iBos Limited. I
            am passionate about finding innovative solutions and consistently
            strive to make meaningful contributions in collaborative work
            environments. Throughout my career, I have had the privilege of
            working in diverse teams, both for development projects and
            programming contests, and have consistently achieved our team's
            objectives. I am dedicated to furthering my exploration and
            knowledge within the programming world, as I believe in continuous
            learning and growth. Thank you for considering my profile.
          </p>
        </Box>
        <Box>
          <img className="w-full" src={img} alt="" />
        </Box>
      </Box>
    </Container>
  );
};

export default About;
